import i18n from "@/i18n";
import { InferType, boolean, mixed, object, string } from "yup";

export const AchSecurityDepositSchema = object({
  transferType: string().required().oneOf(["ach", "swift"]),
  accountHolderName: string().required(
    i18n.t("Account Holder Name is required", { ns: "securityDeposit" })
  ),
  bankInstitutionName: string().required(
    i18n.t("Bank Name is required", { ns: "securityDeposit" })
  ),
  bankRoutingNumber: string().when("transferType", {
    is: "ach",
    then: (schema) =>
      schema.required(
        i18n.t("ABA/Routing Number is required", { ns: "securityDeposit" })
      ),
  }),
  bankAccountNumber: string().required(
    i18n.t("Bank Account Number is required", { ns: "securityDeposit" })
  ),
  bankSWIFTCode: string().when("transferType", {
    is: "swift",
    then: (schema) =>
      schema.required(
        i18n.t("SWIFT Code is required", { ns: "securityDeposit" })
      ),
  }),
  bankSortCode: string().when("transferType", {
    is: "swift",
    then: (schema) =>
      schema.required(
        i18n.t("Bank/Sort Code is required", { ns: "securityDeposit" })
      ),
  }),
  bankCountry: string().when("transferType", {
    is: "swift",
    then: (schema) =>
      schema.required(
        i18n.t("Bank Country is required", { ns: "securityDeposit" })
      ),
  }),
  bankAddress: string().when("transferType", {
    is: "swift",
    then: (schema) =>
      schema
        .required(i18n.t("Bank Address is required", { ns: "securityDeposit" }))
        .min(1, i18n.t("Bank Address is required", { ns: "securityDeposit" })),
  }),
  termsAndConditions: boolean()
    .required()
    .test({
      name: "termsAndConditions",
      message: i18n.t("You must agree to the terms and conditions", {
        ns: "securityDeposit",
      }),
      test: (value) => value === true,
    }),
  file: mixed<File>()
    .required()
    .test({
      name: "file",
      message: i18n.t("Accepted file types: JPG, PNG, BMP or PDF", {
        ns: "securityDeposit",
      }),
      test: (value: File) =>
        ["image/jpeg", "image/png", "image/bmp", "application/pdf"].includes(
          value.type
        ),
    }),
});

export type AchSecurityDepositSchemaType = InferType<
  typeof AchSecurityDepositSchema
>;
